import { useEffect, useMemo } from "react";

// Every search is a billed Algolia request, and searchAsYouType otherwise sends one per keystroke.
// 250 ms sits just above the median gap between keystrokes (~167 ms, Dhakal et al. CHI 2018), so a
// word typed in one go becomes about one request. An emptied box searches at once.
export const SEARCH_DEBOUNCE_MS = 250;

export default function useDebouncedQueryHook(delay = SEARCH_DEBOUNCE_MS) {
  const debounced = useMemo(() => {
    let timer;
    const queryHook = (query, search) => {
      clearTimeout(timer);
      if (query === "") {
        search(query);
        return;
      }
      timer = setTimeout(() => search(query), delay);
    };
    queryHook.cancel = () => clearTimeout(timer);
    return queryHook;
  }, [delay]);

  useEffect(() => debounced.cancel, [debounced]);

  return debounced;
}
